// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavigationBar_navbar__3jLgM","menu":"NavigationBar_menu__o4VqO"};